import React from 'react';
import DetailPageAllComponent from './all-components';
import {connect} from 'react-redux';
import {fetchvenueDetails} from '../../action/apiCallActions';
import Seo from './seoPage.js';

class Detail extends React.Component{




  componentDidMount(){
    if(!this.props.OfferDetails ){
      this.props.dispatch(fetchvenueDetails());
    }
    window.scrollTo(0,0);
  }

  render(){
    try{

       var allComponent = this.props.OfferDetails ? <DetailPageAllComponent/> : <span/> ;

    }catch(err){

    }

    return (
      <div>
         <Seo detail = {this.props.OfferDetails} />
         {allComponent}

      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    OfferDetails : state.OfferDetails,
    location : state.Location
  };
}


export default connect(mapStateToProps)(Detail);



// WEBPACK FOOTER //
// ./src/components/Offer-detail-page/offer-detail-page.js